angular.module('core')
  .directive('progressBar', function() {
    return {
      restrict: 'E',
      scope: {
        value: '@',
        max: '@'
      },
      template: "<div class='progress-bar-box'><div class='progress-bar-bar'></div></div>",
      link: function($scope, element, attrs) {

        function updateProgress() {
          var progress = 0;

          var max = $scope.max || 100;
          progress = Math.min($scope.value, max) / max * element.find('.progress-bar-box').width();
          element.find('.progress-bar-bar').css('width', progress);
        }
        $scope.$watch('value', updateProgress);
      }
    };
  });

